import type { setBannerMessage, setLoading, setSitewideBanner, setUser } from '@/store/actions';

// Redux Action Names
export const SET_USER = 'SET_USER';
export const SET_LOADING = 'SET_LOADING';
export const SET_PARTNER = 'SET_PARTNER';
export const SET_BANNER_MESSAGE = 'SET_BANNER_MESSAGE';
export const SET_SITEWIDE_BANNER = 'SET_SITEWIDE_BANNER';

export type SetUserAction = typeof setUser;

export type SetLoadingAction = typeof setLoading;

// Banner Message
export type SetBannerMessageAction = typeof setBannerMessage;

// Sitewide Banner
export type SetSitewideBannerAction = typeof setSitewideBanner;
